export class WlSubmit extends CustomEvent<EventInit> {

    static type: string = 'wl-submit';

    constructor() {
        super(WlSubmit.type, {bubbles: true, composed: true});
    }
}